import React from 'react';
import Moment from 'react-moment';
import {connect} from 'react-redux';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import { getSafe } from '../../helpers/utils';

function TrainPreview ({ guest, currentLanguage }) {

	const langCode = currentLanguage?.code ? currentLanguage.code : 'en';

	return (
		<>
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-arrival-station" fallback="Arrival Station" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					{getSafe(() => guest.train.arrival_station, 'n/a')}
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-arrival-date" fallback="Arrival Date" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.train.arrival_date, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-arrival-time" fallback="Arrival Time" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.train.arrival_time, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-departure-station" fallback="Departure Station" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					{getSafe(() => guest.train.departure_station, 'n/a')}
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-departure-date" fallback="Departure Date" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="DD/MM/YYYY">{getSafe(() => guest.train.departure_date, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="train-departure-time" fallback="Departure Time" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					<Moment locale={langCode} format="HH:mm">{getSafe(() => guest.train.departure_time, 'n/a')}</Moment>
				</div>
			</div>
			<hr/>

			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="word-comments" fallback="Comments"/></label>
				</div>
				<div className="col-lg-8 col-12">
					{getSafe(() => guest.train.comments, 'n/a')}
				</div>
			</div>
		</>
	)
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(TrainPreview);
